import { render } from "./svgIcon.vue?vue&type=template&id=582adc06&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"

import "./svgIcon.vue?vue&type=style&index=0&id=582adc06&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582adc06"]])

export default __exports__